export function encodeToBase64(str: string): string {
  return btoa(
    new TextEncoder()
      .encode(str)
      .reduce((data, byte) => data + String.fromCharCode(byte), '')
  )
}

export function decodeFromBase64(str: string): string {
  return new TextDecoder().decode(
    Uint8Array.from(atob(str), (c) => c.charCodeAt(0))
  )
}

export class PKCE {
  base64URLEncode(str: string): string {
    return str.toString().replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
  }

  async sha256(buffer: string): Promise<ArrayBuffer> {
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(buffer))
  }

  async generateAuthorizationKeys() {
    const randomBytes = new Uint8Array(32)
    crypto.getRandomValues(randomBytes)
    const code_verifier = this.base64URLEncode(btoa(String.fromCharCode(...randomBytes)))
    const hash = await this.sha256(code_verifier)
    const code_challenge = this.base64URLEncode(
      btoa(String.fromCharCode(...new Uint8Array(hash)))
    )

    return { code_challenge, code_verifier }
  }
}

export default new PKCE()
